import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ReaderTheme } from '@/types';

export const MIN_FONT_SIZE = 15;
export const MAX_FONT_SIZE = 26;

interface ReaderState {
  /** Preferencia separada del tema global, por decisión de producto. */
  readerTheme: ReaderTheme;
  fontSize: number;
  setReaderTheme: (theme: ReaderTheme) => void;
  setFontSize: (size: number) => void;
  increase: () => void;
  decrease: () => void;
}

function clamp(size: number): number {
  return Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, size));
}

export const useReaderStore = create<ReaderState>()(
  persist(
    (set, get) => ({
      readerTheme: 'light',
      fontSize: 18,
      setReaderTheme: (readerTheme) => set({ readerTheme }),
      setFontSize: (size) => set({ fontSize: clamp(size) }),
      increase: () => set({ fontSize: clamp(get().fontSize + 1) }),
      decrease: () => set({ fontSize: clamp(get().fontSize - 1) }),
    }),
    { name: 'relatario:reader' },
  ),
);
